import { MouseEvent, useState } from 'react';
import EditorCollapseIcon from '@atlaskit/icon/core/collapse-horizontal';
import EditorExpandIcon from '@atlaskit/icon/core/expand-horizontal';
import type { EditorAppearance } from '@atlaskit/editor-common/types';
import { actionButton } from './BreadcrumbActions';
import Tooltip from '@atlaskit/tooltip';

interface FullWidthToggleProps {
  appearance: EditorAppearance;
  onFullWidthChange: (fullWidthMode: boolean) => void;
}

export const FullWidthToggle = ({
  appearance,
  onFullWidthChange
}: FullWidthToggleProps) => {
  const [fullWidthMode, setFullWidthMode] = useState(
    appearance === 'full-width'
  );

  const toggleFullWidthMode = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    const nextMode = !fullWidthMode;
    setFullWidthMode(nextMode);
    onFullWidthChange(nextMode);
  };

  return (
    <Tooltip
      content={fullWidthMode ? 'Make page fixed-width' : 'Make page full-width'}
      position="bottom"
    >
      <button css={actionButton} onClick={toggleFullWidthMode}>
        {fullWidthMode ? (
          <EditorCollapseIcon label="Make page fixed width" />
        ) : (
          <EditorExpandIcon label="Make page full width" />
        )}
      </button>
    </Tooltip>
  );
};
